<template>
  <site-banner pagina="blog" />

  <div v-if="!pending" class="containter post-lista">
    <div class="row">
      <div class="col-lg-8">
        <div class="row justify-content-center text-center">
          <div class="col-lg-8 col-lg-12">
            <nuxt-img
              loading="lazy"
              class="card-img-top"
              :alt="post.titulo"
              :src="post.imagem_site"
            />
          </div>
          <div class="row">
            <div class="col-lg-12">
              <h1 class="my-5 mx-5">{{ post.titulo }}</h1>
              <p class="my-5 mx-5">{{ post.descricao }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <!-- <div class="row">
          <div class="col w-100">
            <div v-if="locale == 'pt'">
              <formulario-agenda-brasil />
            </div>
            <div v-if="locale == 'es'">
              <formulario-agenda-uruguai />
            </div>
          </div>
        </div> -->
        <div class="row">
          <div class="col w-100">
            <site-post-sobre />
          </div>
        </div>
      </div>
    </div>
  </div>

  <site-noticias />
</template>

<script setup>
const { t, locale } = useI18n();
const { slug } = useRoute().params;
const { data: post, pending } = await useFetch(`/api/site/posts/${slug}`);

useSeoMeta({
  title: `${post?.value?.titulo} - Blog ${t("sorrifacil")}`,
  ogTitle: `${post?.value?.titulo} - Blog ${t("sorrifacil")}`,
  description: `${t("Leia nossa publicação")} ${post?.value?.titulo} - ${t(
    "sorrifacil"
  )}`,
  ogDescription: `${t("Leia nossa publicação")} ${post?.value?.titulo} - ${t(
    "sorrifacil"
  )}`,
  ogImage: post?.value?.imagem_site,
});
</script>

<script>
export default {
  name: "PostPagina",
};
defineI18nRoute({
  paths: {
    pt: "/blog/[slug]",
    es: "/blog/[slug]",
  },
});
</script>
